import React from 'react';
import { styled } from '@glitz/react';
import { ResponsiveSize, ArticleTag, TextBlockSmall, H2 } from 'Shared/SharedComponents/atoms/Typography';
import Link from 'Shared/Link';
import ArticleListViewModel from 'MagazineStart/ArticleListViewModel.type';
import { Preset, Ratio, RatioPicture } from 'Shared/Image/Ratio';
import { createGridClasses, createOffsetGridClassLarge } from 'Shared/grid';
import * as style from 'Shared/Style';

const ListLayoutWrap = styled.div({
  ['@media ' + style.mediaUpToLarge]: {
    marginBottom: '40px',
  },
})

const ListLayoutLink = styled(Link, {
  alignItems: 'center',
  textDecoration: 'none',
  color: style.colors.monochrome.black,
  width: '100%',
  border: {
    bottom: {
      width: '1px',
      style: 'solid',
      color: `${style.colors.monochrome.mediumGrey}`,
    },
  },
  padding: { y: '24px' },

  ['@media ' + style.mediaUpToLarge]: {
    padding: { y: '16px' },
    display: 'flex',
    columnGap: '16px',
  },
})

const ListLayoutImage = styled(RatioPicture, {
  ['@media ' + style.mediaUpToLarge]: {
    width: '60px',
    flexBasis: '60px',
  },
})

const ListLayoutMobileContent = styled.div({
  flexGrow: 1, display: 'flex', flexDirection: 'column', rowGap: '8px'
})

const ListLyaoutTextBlock = styled(TextBlockSmall, {
  marginBottom: '8px'
})

const ListLayout = (props: { articleListViewModel: ArticleListViewModel; isCompact: boolean }) => {
  const { articleListViewModel, isCompact } = props;
  return (
    <ListLayoutWrap>
      {articleListViewModel.articles.map((article, index) => (
        <ListLayoutLink
          className={isCompact ? '' : 'grid'}
          key={index}
          to={article.url}
          draggable={false}
        >
          <ListLayoutImage
            className={createGridClasses(0, 1)}
            src={article.image?.url}
            title={article.name}
            alt={article.name}
            ratio={Ratio.FourToThree}
            preset={Preset.MagazineListItemThumb}
            borderRadius={8}
          />
          {isCompact ? (
            <ListLayoutMobileContent>
              <H2 fontSize={ResponsiveSize.D40_M18} upperCase={false}>
                {article.heading}
              </H2>
              <ArticleTag>{article.tag}</ArticleTag>
            </ListLayoutMobileContent>
          ) : (
            <>
              <div className={createGridClasses(0, 7, createOffsetGridClassLarge(2))}>
                <H2 fontSize={ResponsiveSize.D40_M18} upperCase={false}>
                  {article.heading}
                </H2>
              </div>
              <span className={createGridClasses(0, 2, createOffsetGridClassLarge(9))}>
                <ListLyaoutTextBlock upperCase={false}>
                  {articleListViewModel.labels.category}
                </ListLyaoutTextBlock>
                <ArticleTag>{article.tag}</ArticleTag>
              </span>
              <span className={createGridClasses(0, 2, createOffsetGridClassLarge(11))}>
                <ListLyaoutTextBlock upperCase={false}>
                  {articleListViewModel.labels.tags}
                </ListLyaoutTextBlock>
                <ArticleTag upperCase>
                  {article.tags?.slice(0, 3).join(', ')}
                  {(article?.tags?.length ?? 0) > 3 && `, +${article?.tags?.length - 3}`}
                </ArticleTag>
              </span>
            </>
          )}
        </ListLayoutLink>
      ))}
    </ListLayoutWrap>
  );
};

export default ListLayout;